import { BaseApi } from '../BaseApi'
import { ThemeResult } from './types'

export class ThemeApi {
  public static async load() {
    return BaseApi.authenticatedCall()
      .url('v1/mobile/theme/load')
      .get()
      .json(json => json) as Promise<ThemeResult>
  }
}
